var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [
            { icon: "users", path: "/legajos", page: "LEGAJOS" },
            { icon: "circle", page: _vm.getName() },
          ],
        },
      }),
      _c(
        "v-container",
        [
          _c(
            "v-tabs",
            {
              staticClass: "custom-tabs",
              attrs: {
                "background-color": "#fff",
                "slider-color": "transparent",
              },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            _vm._l(_vm.items, function (item, index) {
              return _c(
                "v-tab",
                {
                  key: index,
                  staticClass: "custom-tab",
                  class: { "active-tab": _vm.tab === index },
                },
                [_vm._v(" " + _vm._s(item) + " ")]
              )
            }),
            1
          ),
          _c(
            "v-tabs-items",
            {
              attrs: { "background-color": "transparent" },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            _vm._l(_vm.items, function (item, index) {
              return _c(
                "v-tab-item",
                { key: item },
                [
                  index === 0
                    ? _c("LegajoInfo", {
                        attrs: {
                          legajo: _vm.legajo,
                          loading_legajo: _vm.loading_legajo,
                          service: _vm.legajoService,
                        },
                      })
                    : index === 1
                    ? _c("LegajoDocuments", {
                        attrs: {
                          folders: _vm.folders,
                          loading_folders: _vm.loading_folders,
                          service: _vm.legajoService,
                          legajo_id: _vm.legajo_id,
                        },
                        on: {
                          loadFolders: function ($event) {
                            return _vm.loadFolders(_vm.$route.params.id)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }